const pages = {
  access_levels: {
    create: "Créer un niveau d'accès",
    edit: "Éditer un niveau d'accès",
  },
  controllers: {
    activate: 'Activer un contrôleur',
    edit: 'Éditer un contrôleur',
  },
  credentials: {
    create: 'Créer un identifiant',
    edit: 'Éditer un identifiant',
  },
  doors: {
    edit: 'Éditer une porte',
  },
  holidays: {
    create: 'Créer des jours fériés',
    edit: 'Éditer des jours fériés',
  },
  inputs: {
    edit: 'Éditer une entrée',
  },
  interlocks: {
    create: 'Créer un sas de sécurité',
    edit: 'Éditer un sas de sécurité',
  },
  outputs: {
    edit: 'Éditer une sortie',
  },
  schedules: {
    create: 'Créer un horaire',
    edit: 'Éditer un horaire',
  },
  sites: {
    create: 'Créer un site',
  },
  users: {
    create: 'Créer un utilisateur',
    edit: 'Éditer un utilisateur',
  },
};

export default pages;
